let colorPrintName = "";
switch (window.Shopify.locale) {
  case "en":
    colorPrintName = "Color/Print Name";
    break;
  case "fr":
    colorPrintName = "Couleur/Nom d'impression";
    break;
  case "de":
    colorPrintName = "Farbe/Druckname";
    break;
  case "it":
    colorPrintName = "Colore/Nome stampa";
    break;
  default:
    break;
}

function handleize(str) {
  const safe = (str ?? "").toString();
  const handle = safe.replace(/[^\w\s]/gi, "").toLowerCase();
  return handle.replace(/\s+/g, "-");
}

function isColorPrintOptionName(name) {
  const value = String(name || "").toLowerCase();

  return (
    value.includes("color") ||
    value.includes("colour") ||
    value.includes("couleur") ||
    value.includes("farbe") ||
    value.includes("colore") ||
    value.includes("print") ||
    value.includes("impression") ||
    value.includes("druck") ||
    value.includes("stampa")
  );
}

function getColorPrintFieldset(root) {
  if (!root) return null;

  return Array.from(root.querySelectorAll("fieldset")).find((fieldset) => {
    return isColorPrintOptionName(fieldset.getAttribute("option-name"));
  });
}

function getLabelForInput(fieldset, input) {
  if (!fieldset || !input) return null;

  return Array.from(fieldset.querySelectorAll("label")).find((label) => {
    return label.getAttribute("for") === input.id || label.htmlFor === input.id;
  }) || (input.nextElementSibling?.tagName === "LABEL" ? input.nextElementSibling : null);
}

function uniqueOptionCandidates(values) {
  return [...new Set(
    values
      .map((value) => String(value || "").trim())
      .filter(Boolean)
  )];
}

function getOptionMatchCandidates(root, optionIndex, selectedValue) {
  const fieldsets = Array.from(root?.querySelectorAll("fieldset") || []);
  const fieldset = fieldsets[optionIndex];
  const checkedInput = fieldset?.querySelector("input:checked");
  const label = getLabelForInput(fieldset, checkedInput);

  return uniqueOptionCandidates([
    selectedValue,
    checkedInput?.value,
    label?.getAttribute("data-swatch-image-value"),
    label?.getAttribute("data-swatch-value"),
    label?.getAttribute("option-value"),
    label?.textContent,
  ]);
}

function optionValueMatches(selectedValue, variantValue) {
  const selected = String(selectedValue || "").trim();
  const variant = String(variantValue || "").trim();

  if (!selected || !variant) return false;
  return selected.toLowerCase() === variant.toLowerCase() || handleize(selected) === handleize(variant);
}

function findInputByOptionValue(fieldset, value) {
  const targetHandle = handleize(value);

  return Array.from(fieldset?.querySelectorAll("input") || []).find((input) => {
    const label = getLabelForInput(fieldset, input);
    const candidates = uniqueOptionCandidates([
      input.value,
      label?.getAttribute("data-swatch-image-value"),
      label?.getAttribute("data-swatch-value"),
      label?.getAttribute("option-value"),
      label?.textContent,
    ]);

    return candidates.some((candidate) => {
      return optionValueMatches(candidate, value) || handleize(candidate) === targetHandle;
    });
  });
}

function getMediaAltColorValue(variant) {
  const mediaAlt =
    variant?.featured_media?.alt ||
    variant?.featured_image?.alt ||
    "";

  return String(mediaAlt).split(" - ").pop().trim();
}

// ----- Badge parity with PLP -----
function _toUnderscore(handle) {
  return String(handle || '').replace(/-/g, '_');
}

// PLP rule: only "New" / "Just Arrived" are gated by show_badge_child_level
function _shouldShowNewish(tags, colorOption1) {
  const lcTags = (tags || []).map(t => String(t).toLowerCase());
  const childLevel = lcTags.includes('show_badge_child_level');
  if (!childLevel) return true; // show for all colors
  const hyphenHandle = handleize(colorOption1 || '');
  const underscoreHandle = _toUnderscore(hyphenHandle);
  return lcTags.includes(`show_badge:${underscoreHandle}`); // only listed colors get New/Just Arrived
}

function _applyNewishVisibility(visible) {
  // Only toggle labels whose text is "New" or "Just Arrived"
  document.querySelectorAll('media-gallery .product__custom_label').forEach(el => {
    const txt = (el.textContent || '').trim().toLowerCase();
    if (txt === 'new' || txt === 'just arrived') {
      el.style.display = visible ? 'block' : 'none';
    }
  });
}

const capitalizeAndRemoveHyphens = (str) => {
  if (str?.includes("-")) {
    return str.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
  }
  return str
};

function getFocusableElements(container) {
  if (!container) return;
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id)
  }
  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
  });
  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape)
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown)
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus()
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus()
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}
try {
  document.querySelector(":focus-visible")
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN",];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = !1
    }
  });
  window.addEventListener("mousedown", (event) => {
    mouseClick = !0
  });
  window.addEventListener("focus", () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove("focused");
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add("focused")
  }, !0)
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*")
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*")
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", !1);
  summaryElement.focus()
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: !0
    });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)))
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }
  onInputChange(event) {
    this.validateQtyRules()
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max)
    }
  }
}
customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    },
  }
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {}
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent("on" + eventName, callback)
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options.method || "post";
  var params = options.parameters || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form)
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options.hideElement || province_domid);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince()
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler()
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none"
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt)
      }
      this.provinceContainer.style.display = ""
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt)
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents()
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.localization-selector)").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)))
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement)
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus)
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia("(max-width: 1100px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", !0);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus)
      }, 100)
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    });
    summaryElement.setAttribute("aria-expanded", !0);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(event, elementToFocus = !1) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening")
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open")
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle)
  }
  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    })
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement)
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", !1);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement)
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"))
        }
      }
    };
    window.requestAnimationFrame(handleAnimation)
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add("menu-open");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    });
    summaryElement.setAttribute("aria-expanded", !0);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize)
  }
  onResize = () => {
    this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        const swiperSlide = event.target.closest(".swiper-slide");
        if (swiperSlide) {
          return
        }
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) { }
      })
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.hide()
        }
      })
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = !0;
    document.body.appendChild(this)
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia()
  }
  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia()
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    })
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this))
  }
  loadContent(focus = !0) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0));
      this.setAttribute("loaded", !0);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        deferredElement.play()
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = !1;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update()
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages()
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }))
    }
    if (this.enableSliderLooping) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled")
    } else {
      this.prevButton.removeAttribute("disabled")
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled")
    } else {
      this.nextButton.removeAttribute("disabled")
    }
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft)
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition)
  }
  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    })
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = !0;
    this.pauseButton = this.querySelector('button[name="pause"]');
    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = !1;
      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
      });
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener("click", () => {
          this.announcementBarArrowButtonWasClicked = !0
        }, {
          once: !0
        })
      });
      if (this.pauseButton) {
        this.pauseButton.addEventListener("click", this.togglePause.bind(this))
      }
    }
    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }
  togglePause() {
    const isPaused = this.slider.dataset.paused === "true";
    if (isPaused) {
      this.play()
    } else {
      this.pause()
    }
  }
  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = !0;
      this.play()
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play()
    }
  }
  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = !0;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return
    }
    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0
    }
    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name)
  }
  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      })
    }, this.announcerBarAnimationDelay)
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current")
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0)
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }
  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play()
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.slider.dataset.paused !== "true") {
      this.play()
    }
  }
  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play()
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause()
      }
    } else if (this.announcementBarSlider.contains(event.target) && this.slider.dataset.paused !== "true") {
      this.pause()
    }
  }
  play() {
    this.slider.setAttribute("aria-live", "off");
    this.slider.dataset.paused = "false";
    if (this.pauseButton) {
      this.pauseButton.setAttribute("aria-pressed", "false")
    }
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite");
    this.slider.dataset.paused = "true";
    if (this.pauseButton) {
      this.pauseButton.setAttribute("aria-pressed", "true")
    }
    clearInterval(this.autoplay)
  }
  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow)
    }
  }
  autoRotateSlides() {
    if (this.slider.dataset.paused === "true") return;
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar()
  }
  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex")
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex")
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1")
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1")
      }
    });
    this.wasClicked = !1
  }
  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";
    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;
    const shouldMoveNext = (button === "next" && !isLastSlide) || (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);
    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`)
    }, this.announcerBarAnimationDelay * 2)
  }
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (e) => this.onVariantChange(e));
    this.stickyVariants = document.querySelector(".product-sticky-form sticky-variant-radios");
    this.currentTemplate = this.getAttribute("current-template")
  }
  async onVariantChange(e) {
    const targetName = e.target.name;
    const optionsUpdate = this.updateOptions(targetName);
    this.syncToSticky(targetName);
    this.updateMasterId();
    this.toggleAddButton(!0, "", !1);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (isColorPrintOptionName(targetName)) {
      this.updateMedia();
    }
    if (!this.currentVariant) {
      this.toggleAddButton(!0, "", !0);
      this.setUnavailable()
    } else {
      this.updateURL();
      this.updateVariantInput();
      await optionsUpdate;
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku()
    }
  }
  syncToSticky(targetName) {
    if (this.stickyVariants) {
      this.stickyVariants.sync(this.options, targetName)
    }
  }
  async sync(options, targetName) {
    this.options = options;
    this.syncOptions();
    const optionsUpdate = this.updateOptions(colorPrintName);
    this.updateMasterId();
    this.toggleAddButton(!0, "", !1);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateMedia();
    if (!this.currentVariant) {
      this.toggleAddButton(!0, "", !0);
      this.setUnavailable()
    } else {
      this.updateURL();
      this.updateVariantInput();
      await optionsUpdate;
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSku()
    }
    if (isColorPrintOptionName(targetName) && this.currentTemplate === "product") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }
  syncOptions() {
    const fieldsets = this.querySelectorAll("fieldset");
    this.options.forEach((optionValue, index) => {
      fieldsets[index].querySelectorAll("input").forEach((inputElement) => {
        inputElement.checked = inputElement.value == optionValue
      })
    })
  }
  updateSku() {
    const sku = document.querySelector(".variant-sku");
    if (sku) {
      sku.textContent = `SKU: ${this.currentVariant.sku}`
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value)
  }
  updateMasterId() {
    const optionCandidates = (this.options || []).map((optionValue, index) => {
      return getOptionMatchCandidates(this, index, optionValue);
    });

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return (optionCandidates[index] || [this.options[index]]).some((candidate) => {
          return optionValueMatches(candidate, option);
        })
      }).includes(!1)
    })
  }
  updateMedia() {
    ////console.log("updateMedia");

    // Only products that actually have a color/print option
    // should drive the gallery by "color". Do not rely on exact translated text.
    const colorFieldset = getColorPrintFieldset(this);
    if (!colorFieldset) {
      // Gift cards / non-color products: don't touch the media gallery.
      return;
    }

    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const colorOptionIndex = fieldsets.indexOf(colorFieldset);

    if (colorOptionIndex < 0) return;

    const selectedColor = (this.options && this.options[colorOptionIndex])
      ? String(this.options[colorOptionIndex]).toLowerCase()
      : "";
    const selectedColorCandidates = getOptionMatchCandidates(this, colorOptionIndex, this.options[colorOptionIndex]);

    if (!selectedColor) return;

    const currentVariantByColor = this.getVariantData().find((variant) => {
      const variantColor =
        variant.options?.[colorOptionIndex] ||
        variant[`option${colorOptionIndex + 1}`] ||
        "";

      return selectedColorCandidates.some((candidate) => {
        return optionValueMatches(candidate, variantColor);
      });
    });

    //console.log("currentVariantByColor", currentVariantByColor);
    if (!currentVariantByColor || !currentVariantByColor.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.sectionOnly}`
    );
    if (!mediaGallery || typeof mediaGallery.setActiveMedia !== "function") return;

    // this is still used on real Color/Print products
    const stableColorValue =
      getMediaAltColorValue(currentVariantByColor) ||
      currentVariantByColor.options?.[colorOptionIndex] ||
      currentVariantByColor[`option${colorOptionIndex + 1}`] ||
      this.options[colorOptionIndex] ||
      "";

    const colorHandle = handleize(stableColorValue);
    const mediaId = `${this.dataset.sectionOnly}-${currentVariantByColor.featured_media.id}`;

    //console.log("mediaGallery", mediaGallery);
    //console.log("mediaId", mediaId, "colorHandle", colorHandle);

    mediaGallery.setActiveMedia(mediaId, !0, colorHandle);

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.sectionOnly} .product-media-modal__content`
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${currentVariantByColor.featured_media.id}"]`
      );
      if (newMediaModal) {
        modalContent.prepend(newMediaModal);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const params = new URLSearchParams(window.location.search);
    params.set("variant", this.currentVariant.id);
    window.history.replaceState({}, "", `${this.dataset.url}?${params.toString()}`)
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.sectionOnly ? this.dataset.sectionOnly : this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", {
        bubbles: !0
      }))
    })
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = ""
    }
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }
  applyTagBasedDiscountPrice(price, selectedPrice = this.currentVariant?.price) {
    if (!price) return;

    const regularPriceElem =
      price.querySelector(".price__regular .price-item.price-item--regular") ||
      price.querySelector(".price-item.price-item--regular");
    if (!regularPriceElem) return;

    price.querySelectorAll(".tag-based-discount-price").forEach((node) => node.remove());
    price
      .querySelectorAll(".price-item.price-item--regular")
      .forEach((node) => node.classList.remove("tag-based-line-through-price"));

    if (!this.__tagBasedDiscountPercentage || this.__excludeDiscount) {
      const priceRegular = price.querySelector(".price__regular");
      const priceSale = price.querySelector(".price__sale");
      if (priceRegular) priceRegular.style.display = "";
      if (priceSale) priceSale.style.display = "";
      return;
    }

    const discountedPriceHtml = `${currencySymbol}${(
      (selectedPrice * this.__tagBasedDiscountPercentage) /
      100
    ).toFixed(2)} ${window.Shopify.currency.active}`;

    const priceRegular = price.querySelector(".price__regular");
    const priceSale = price.querySelector(".price__sale");
    if (priceRegular) priceRegular.style.display = "block";
    if (priceSale) priceSale.style.display = "none";

    regularPriceElem.classList.add("tag-based-line-through-price");
    const salePrice = document.createElement("span");
    salePrice.innerHTML = `<span class="price-item price-item--sale tag-based-discount-price">${discountedPriceHtml}</span>`;
    regularPriceElem.insertAdjacentElement("afterend", salePrice);
  }
  applyTagBasedDiscountPrices(selectedPrice = this.currentVariant?.price) {
    const productSection = this.closest("section") || document;
    const priceIds = [
      `price-${this.dataset.section}`,
      `sticky-price-${this.dataset.section}`,
      this.dataset.sectionOnly ? `price-${this.dataset.sectionOnly}` : "",
      this.dataset.sectionOnly ? `sticky-price-${this.dataset.sectionOnly}` : "",
    ].filter(Boolean);

    const priceBlocks = [
      ...[...new Set(priceIds)].map((id) => document.getElementById(id)),
      ...productSection.querySelectorAll('[id^="price-"], [id^="sticky-price-"]'),
    ].filter(Boolean);

    [...new Set(priceBlocks)].forEach((price) =>
      this.applyTagBasedDiscountPrice(price, selectedPrice)
    );
  }
  revealProductPrices() {
    const productSection = this.closest("section") || document;
    const priceIds = [
      `price-${this.dataset.section}`,
      `sticky-price-${this.dataset.section}`,
      this.dataset.sectionOnly ? `price-${this.dataset.sectionOnly}` : "",
      this.dataset.sectionOnly ? `sticky-price-${this.dataset.sectionOnly}` : "",
    ].filter(Boolean);
    const priceBlocks = [
      ...[...new Set(priceIds)].map((id) => document.getElementById(id)),
      ...productSection.querySelectorAll('[id^="price-"], [id^="sticky-price-"]'),
    ].filter(Boolean);
    [...new Set(priceBlocks)].forEach((price) => price.classList.remove("visibility-hidden"));
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.sectionOnly}`).then((response) => response.text()).then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      this.revealProductPrices();
      this.applyTagBasedDiscountPrices();
      requestAnimationFrame(() => this.applyTagBasedDiscountPrices());
      if (window.sopRefreshLoyaltyLionPdp) window.sopRefreshLoyaltyLionPdp();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      graphenehc.track({
        scope: "view",
        action: "add",
        data: {
          product_id: this.currentVariant.featured_image.product_id,
          variant_id: this.currentVariant.id,
        },
      });
      const btn = document.querySelector("form[action='/cart/add'] button[type='submit'], form[action='/cart/add'] input[type='submit'], form[action='/cart/add'] button");
      if (btn) {
        btn.addEventListener("click", function (e) {
          graphenehc.track({
            scope: "basket",
            action: "add",
            data: {
              product_id: e.target.parentElement.nextElementSibling.getAttribute("value"),
              variant_id: e.target.parentElement.parentElement.querySelector("input.product-variant-id").getAttribute("value"),
            },
          })
        })
      }
    })
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyProductForm = document.getElementById(`sticky-product-form`);
    if (!stickyProductForm) return;
    const stickyAddButton = stickyProductForm.querySelector('[name="add"]');
    const stickyAddButtonText = stickyProductForm.querySelector('[name="add"] > span');
    if (!stickyAddButton) return;
    if (disable) {
      stickyAddButton.setAttribute("disabled", "disabled");
      if (text) stickyAddButtonText.textContent = text
    } else {
      stickyAddButton.removeAttribute("disabled");
      stickyAddButtonText.textContent = window.variantStrings.addToCart
    }
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart
    }
    if (!modifyClass) return
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.sectionOnly ? this.dataset.sectionOnly : this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.sectionOnly}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.remove("visibility-hidden");
    this.revealProductPrices();
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    const isCandle = this.getAttribute("is-candle") === "true" ? !0 : !1;
    if (!isCandle) {
      this.hideAllSoldoutSwatch();
      this.hideAllSoldoutSwatchRP()
    }
    this.updateOptions(colorPrintName, !0);
    this.syncToSticky();
    this.preselectColorPrintName();
    this.updateMasterId();
  }
  preselectColorPrintName() {
    //console.log("preselectColorPrintName");
    const fieldset = this.querySelector(`fieldset[option-name="${colorPrintName}"]`);
    if (!fieldset) return;
    const initOption = this.options?.[0]?.trim() ?? this.getAttribute("selected-or-first-available-variant-option-0")?.trim();
    if (!initOption) return;
    this.options[0] = initOption;
    const inputs = Array.from(fieldset.querySelectorAll("input"));
    const preselectInput = findInputByOptionValue(fieldset, initOption) || inputs.find((input) => input.value.toLowerCase() === initOption.toLowerCase());
    if (preselectInput) preselectInput.checked = !0;
    //console.log("preselectInput", preselectInput)
  }
  preselectSize() {
    const fieldset = this.querySelector(`fieldset[option-name="Size"], fieldset[option-name="Taille"], fieldset[option-name="Größe"], fieldset[option-name="Misurare"]`);
    if (!fieldset) return;
    //console.log("preselectSize", fieldset);
    const numberOfSizeOptions = fieldset.querySelectorAll("input").length;
    //console.log("numberOfSizeOptions", numberOfSizeOptions);
    if (numberOfSizeOptions === 1) {
      const sizeInput = fieldset.querySelector("input");
      sizeInput.checked = !0;
      //console.log("size input checked", sizeInput)
    } else {
      //console.log("size input not checked")
    }
  }
  async hideAllSoldoutSwatchRP() {
    if (this.querySelector("[related-products]")) {
      const relatedProductsCustomData = JSON.parse(this.querySelector("[related-products]").textContent);
      relatedProductsCustomData.forEach(async (productHandle) => {
        const response = await fetch(`/products/${productHandle}.js`);
        if (response.ok) {
          const data = await response.json();
          const colorKeys = [...new Set(data.variants.map((variant) => variant.option1))];
          const groupPerColor = data.variants.reduce((result, current) => {
            const key = current.option1;
            if (!result[key]) {
              result[key] = []
            }
            result[key].push(current);
            return result
          }, {});
          const newCustomData = {};
          for (const key in groupPerColor) {
            if (colorKeys.includes(key)) {
              newCustomData[key] = groupPerColor[key]
            }
          }
          if (colorKeys.length > 1) {
            const allSoldoutColors = colorKeys.map((key) => {
              const availabilitiesPerKey = newCustomData[key].map((variant) => variant.available);
              const hideSwatch = availabilitiesPerKey.every((element) => element === !1);
              if (hideSwatch) {
                return key
              } else {
                return null
              }
            }).filter((value) => value !== null);
            const initColor = colorKeys.find((color) => !allSoldoutColors.includes(color));
            const sizesWrapper = document.querySelector('fieldset.product-form__input[option-name="Size"], fieldset.product-form__input[option-name="Taille"], fieldset.product-form__input[option-name="Größe"], fieldset.product-form__input[option-name="Misurare"]');
            const sizeLabels = [...sizesWrapper.querySelectorAll("label[variant-title]")];
            sizeLabels.forEach((label) => label.setAttribute("variant-title", initColor));
            if (allSoldoutColors.length > 0) {
              allSoldoutColors.forEach((color) => {
                const soldoutColorInput = this.querySelector(`a.color-swatch[value="${color}"]`);
                const soldoutColorStickyInput = document.querySelector(`sticky-variant-radios a.color-swatch[value="${color}"]`);
                soldoutColorInput?.remove();
                soldoutColorStickyInput?.remove();
                const soldoutColorSwatch = this.querySelector(`label[option-value="${color}"]`);
                const soldoutColorStickySwatch = document.querySelector(`sticky-variant-radios label[option-value="${color}"]`);
                soldoutColorSwatch?.remove();
                soldoutColorStickySwatch?.remove()
              })
            }
          }
        }
      });
      const relatedProductSwatches = this.querySelectorAll(".additional-swatch__item");
      if (!relatedProductSwatches || relatedProductSwatches.length === 0) {
        return
      }
      setTimeout(() => {
        relatedProductSwatches.forEach((swatch) => {
          if (!swatch) return;
          const itemWrapper = swatch.querySelector(".item-wrapper");
          if (!itemWrapper) return;
          const child = itemWrapper.firstElementChild;
          if (!child) {
            swatch.remove()
          }
        })
      }, 500)
    }
  }
  hideAllSoldoutSwatch() {
    const customData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const colorKeys = [...new Set(customData.map((variant) => variant.option1))];
    const groupPerColor = customData.reduce((result, current) => {
      const key = current.option1;
      if (!result[key]) {
        result[key] = []
      }
      result[key].push(current);
      return result
    }, {});
    const newCustomData = {};
    for (const key in groupPerColor) {
      if (colorKeys.includes(key)) {
        newCustomData[key] = groupPerColor[key]
      }
    }
    if (colorKeys.length > 1) {
      const allSoldoutColors = colorKeys.map((key) => {
        const availabilitiesPerKey = newCustomData[key].map((variant) => variant.available);
        const hideSwatch = availabilitiesPerKey.every((element) => element === !1);
        if (hideSwatch) {
          return key
        } else {
          return null
        }
      }).filter((value) => value !== null);
      const handleizedAllSoldoutColors = allSoldoutColors.map((color) => handleize(color));
      const imageElements = [...document.querySelectorAll("img")];
      handleizedAllSoldoutColors.forEach((color) => {
        if (imageElements.some((element) => {
          if (element.getAttribute("src")?.includes(color)) {
            element.parentElement.remove();
            element.remove()
          }
        })) { }
      });
      const initColor = colorKeys.find((color) => !allSoldoutColors.includes(color));
      const sizesWrapper = document.querySelector('fieldset.product-form__input[option-name="Size"], fieldset.product-form__input[option-name="Taille"], fieldset.product-form__input[option-name="Größe"], fieldset.product-form__input[option-name="Misurare"]');
      if (sizesWrapper) {
        const sizeLabels = [...sizesWrapper?.querySelectorAll("label[variant-title]")];
        sizeLabels.forEach((label) => label.setAttribute("variant-title", initColor))
      }
      if (allSoldoutColors.length > 0) {
        allSoldoutColors.forEach((color) => {
          const soldoutColorInput = this.querySelector(`input[value="${color}"]`);
          const soldoutColorStickyInput = document.querySelector(`sticky-variant-radios input[value="${color}"]`);
          soldoutColorInput?.remove();
          soldoutColorStickyInput?.remove();
          const soldoutColorSwatch = this.querySelector(`label[option-value="${color}"]`);
          const soldoutColorStickySwatch = document.querySelector(`sticky-variant-radios label[option-value="${color}"]`);
          soldoutColorSwatch?.remove();
          soldoutColorStickySwatch?.remove()
        })
      }
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const colorParamValue = capitalizeAndRemoveHyphens(urlParams.get("color-print-name"));
    const selectedOrFirstAvailableVariantOption0 = capitalizeAndRemoveHyphens(this.getAttribute("selected-or-first-available-variant-option-0"));
    const valueToQuery = colorParamValue || selectedOrFirstAvailableVariantOption0;

    // Only check the input if it belongs to the correct fieldset
    const firstFieldset = this.querySelector('fieldset');
    if (firstFieldset && isColorPrintOptionName(firstFieldset.getAttribute("option-name"))) {
      const initCheckedInput = findInputByOptionValue(firstFieldset, valueToQuery);
      if (initCheckedInput) {
        initCheckedInput.checked = !0
      }
    } else {
      // Fallback for non-color products or if first option is not Color/Print Name
      const initFieldset = Array.from(this.querySelectorAll("fieldset")).find((fieldset) => findInputByOptionValue(fieldset, valueToQuery));
      const initCheckedInput = findInputByOptionValue(initFieldset, valueToQuery);
      if (initCheckedInput) {
        initCheckedInput.checked = !0
      }
    }
  }
    handleProductReturnLogic() {
        const returnLogicRoot =
            this.closest(".quickview-modal, .quickview-portal-container") ||
            this.closest('section[id^="MainProduct-"]') ||
            this.closest("section") ||
            document;

        const customReturnData = returnLogicRoot.querySelector("[custom-return-data]");
        if (!customReturnData) return;

        const customReturnTextElem = returnLogicRoot.querySelector(
            ".custom-return-text[data-tag-based-final-sale]"
        );
        if (!customReturnTextElem) return;

        let productJson;
        try {
            productJson = JSON.parse(customReturnData.textContent);
        } catch (e) {
            console.warn("[return] Could not parse product JSON.", e);
            return;
        }

        const MESSAGE = "This item is a final sale.";
        const productTags = (Array.isArray(productJson.tags)
            ? productJson.tags
            : String(productJson.tags || "").split(","))
            .map((tag) => String(tag || "").trim().toLowerCase());
        const hasNonReturnableTag = productTags.includes("non-returnable");
        const hasHygieneFinalSaleTag = productTags.includes("non-returnable-hygiene");

        const _handleize = (s) =>
            typeof handleize === "function"
            ? handleize(s)
            : String(s || "")
                .trim()
                .toLowerCase()
                .replace(/['"]/g, "")
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");

        const isOnSale = (v) =>
            v &&
            v.compare_at_price != null &&
            Number(v.compare_at_price) > Number(v.price);

        const productVariants = Array.isArray(productJson.variants) ? productJson.variants : [];
        const hasSaleVariants = productVariants.some(isOnSale);
        const hasFullPriceVariants = productVariants.some((variant) => !isOnSale(variant));
        // Mixed-price products use the selected variant's sale state. Uniformly priced
        // products retain the existing product-level tag behavior.
        const useVariantSaleState =
            hasNonReturnableTag &&
            !hasHygieneFinalSaleTag &&
            hasSaleVariants &&
            hasFullPriceVariants;
        const hasProductLevelFinalSale =
            hasHygieneFinalSaleTag ||
            (hasNonReturnableTag && !useVariantSaleState) ||
            (!hasNonReturnableTag &&
                !hasHygieneFinalSaleTag &&
                customReturnTextElem.hasAttribute("data-tag-based-final-sale"));

        const getColorFromUrl = () => {
            const sp = new URLSearchParams(window.location.search);
            const v = sp.get("color-print-name");
            return v ? String(v) : "";
        };

        const getSelectedColor = () => {
            const colorFieldset = getColorPrintFieldset(this);
            const checkedColor = colorFieldset?.querySelector('input[type="radio"]:checked');
            if (checkedColor?.value) return checkedColor.value;

            const colorIndex = Array.from(this.querySelectorAll("fieldset")).indexOf(colorFieldset);
            if (colorIndex >= 0 && this.options?.[colorIndex]) return this.options[colorIndex];

            return getColorFromUrl();
        };

        // Related form + variant id input (for current product)
        const baseForm =
            customReturnTextElem.closest("form") ||
            returnLogicRoot.querySelector('form[action^="/cart/add"], form[action="/cart/add"]');

        const variantIdInput =
            baseForm?.querySelector('input[name="id"]') ||
            returnLogicRoot.querySelector('input[name="id"]');

        // Detect Size option for “show early before size selected”
        const sizeOptionName = (() => {
            const opts = productJson.options || [];
            const idx = opts.findIndex((n) => /size/i.test(n) && !/type/i.test(n));
            return idx >= 0 ? opts[idx] : null;
        })();

        const cssEscape = (s) =>
            window.CSS && typeof CSS.escape === "function"
            ? CSS.escape(s)
            : String(s).replace(/["\\]/g, "\\$&");

        const getSelectedOptionValue = (optName, form) => {
            if (!form || !optName) return "";

            const radio = form.querySelector(
            `input[type="radio"][name="${cssEscape(optName)}"]:checked`
            );
            if (radio?.value) return radio.value;

            const select = form.querySelector(
            `select[name="options[${cssEscape(optName)}]"]`
            );
            if (select?.value) return select.value;

            const hidden = form.querySelector(
            `input[name="options[${cssEscape(optName)}]"]`
            );
            if (hidden?.value) return hidden.value;

            return "";
        };

        const hasSizeSelected = (form) => {
            if (!sizeOptionName) return true;
            return (
                !!getSelectedOptionValue(sizeOptionName, this) ||
                !!getSelectedOptionValue(sizeOptionName, form || baseForm)
            );
        };

        const checkbox = customReturnTextElem.querySelector(
            'input[type="checkbox"][name="properties[Note]"]'
        );
        if (!checkbox) return;

        // Track visibility so we don't keep forcing checked/unchecked
        let lastReturnUI = { visible: null, key: null };

        // Compute whether the return checkbox should be shown for current selection
        const computeShouldShow = () => {
            if (hasProductLevelFinalSale) {
            const keyTagged = String(variantIdInput?.value || productJson.id || "tagged-final-sale");
            return { shouldShow: true, key: keyTagged };
            }

            let colorPrintName = _handleize(getSelectedColor());

            // Fallback: derive color from selected variant if URL param missing
            if (!colorPrintName && variantIdInput?.value) {
            const selected = (productJson.variants || []).find(
                (v) => String(v.id) === String(variantIdInput.value)
            );
            if (selected?.option1) colorPrintName = _handleize(selected.option1);
            }

            if (!colorPrintName) return { shouldShow: false, key: "" };

            const variantsForColor = productVariants.filter(
            (v) => _handleize(v.option1) === String(colorPrintName)
            );

            const colorHasSale = variantsForColor.some(isOnSale);
            if (!colorHasSale) return { shouldShow: false, key: String(colorPrintName) };

            // Show early before size is selected
            if (!hasSizeSelected(baseForm)) {
            const keyEarly = String(variantIdInput?.value || colorPrintName || "");
            return { shouldShow: true, key: keyEarly };
            }

            const selectedVariant =
            variantIdInput?.value
                ? productVariants.find(
                    (v) => String(v.id) === String(variantIdInput.value)
                )
                : null;

            if (!isOnSale(selectedVariant)) {
            return { shouldShow: false, key: String(variantIdInput?.value || colorPrintName || "") };
            }

            return { shouldShow: true, key: String(variantIdInput?.value || colorPrintName || "") };
        };

        const setVisibleState = (shouldShow, key) => {
            const label = customReturnTextElem.querySelector("label");

            if (!shouldShow) {
            customReturnTextElem.style.display = "none";
            if (label) label.style.display = "none";

            checkbox.required = false;
            checkbox.disabled = true;
            checkbox.checked = true; // never block add-to-cart when hidden
            checkbox.value = "";
            checkbox.style.display = "none";

            lastReturnUI.visible = false;
            lastReturnUI.key = key || null;
            return;
            }

            // show
            customReturnTextElem.style.display = "";
            if (label) label.style.display = "block";

            checkbox.disabled = false;
            checkbox.required = true;
            checkbox.value = MESSAGE;
            checkbox.style.display = "";

            // Variant-level final sale can change with the selected variant. Product-level
            // final sale should preserve the shopper's checkbox state across quickview
            // variant re-initialization.
            if (!hasProductLevelFinalSale && (lastReturnUI.visible !== true || lastReturnUI.key !== key)) {
            checkbox.checked = false;
            }

            lastReturnUI.visible = true;
            lastReturnUI.key = key;
        };

        const update = () => {
            const { shouldShow, key } = computeShouldShow();
            setVisibleState(shouldShow, key);
        };

        // ----- Dedupe + property normalization across multiple /cart/add forms -----

        // Forms on PDP can be duplicated (main + sticky). We guard and normalize on any /cart/add submit.
        const isCartAddForm = (f) => {
            if (!f || f.tagName !== "FORM") return false;
            const action = (f.getAttribute("action") || "").toLowerCase();
            return action.includes("/cart/add");
        };

        const getFormVariantId = (f) => f?.querySelector('input[name="id"]')?.value || "";

        const ensureProxyNoteInput = (f) => {
            // hidden proxy used when the submitting form does NOT contain the checkbox
            let proxy = f.querySelector('input[data-final-sale-note-proxy="true"]');
            if (!proxy) {
            proxy = document.createElement("input");
            proxy.type = "hidden";
            proxy.setAttribute("data-final-sale-note-proxy", "true");
            proxy.name = "properties[Note]";
            f.appendChild(proxy);
            }
            return proxy;
        };

        const disableAllOtherNoteInputsInForm = (f, keepEl) => {
            const notes = f.querySelectorAll('input[name="properties[Note]"]');
            notes.forEach((el) => {
            if (el === keepEl) return;
            // don't leave stale values around
            el.disabled = true;
            try { el.value = ""; } catch (_) {}
            });
        };

        const GUARD_TTL_MS = 900;
        window.__finalSaleAddGuard = window.__finalSaleAddGuard || new Map();

        const isGuarded = (guardKey) => {
            const now = Date.now();
            const last = window.__finalSaleAddGuard.get(guardKey) || 0;
            if (now - last < GUARD_TTL_MS) return true;
            window.__finalSaleAddGuard.set(guardKey, now);

            // light cleanup
            if (window.__finalSaleAddGuard.size > 50) {
            for (const [k, t] of window.__finalSaleAddGuard.entries()) {
                if (now - t > 5000) window.__finalSaleAddGuard.delete(k);
            }
            }
            return false;
        };

        const bindSubmitGuardToForm = (f) => {
            if (!f || f.dataset.finalSaleReturnGuard === "1") return;
            f.dataset.finalSaleReturnGuard = "1";

            // capture so we run before theme handlers
            f.addEventListener(
            "submit",
            (evt) => {
                if (!isCartAddForm(f)) return;

                const currentVariantId = String(variantIdInput?.value || "");
                const thisFormVariantId = String(getFormVariantId(f) || "");

                // Only act on the current PDP product (skip other product cards/CTL forms)
                if (currentVariantId && thisFormVariantId && thisFormVariantId !== currentVariantId) {
                return;
                }

                const { shouldShow } = computeShouldShow();
                const activeCheckbox =
                    f.querySelector('[data-non-returnable-checkbox], input[type="checkbox"][name="properties[Note]"]') ||
                    checkbox;

                // If return UI is NOT active, ensure we do not submit any stray properties[Note]
                if (!shouldShow) {
                const existingProxy = f.querySelector('input[data-final-sale-note-proxy="true"]');
                if (existingProxy) {
                    existingProxy.disabled = true;
                    existingProxy.value = "";
                }
                // Also disable any other note inputs in this form (defensive)
                disableAllOtherNoteInputsInForm(f, null);
                return;
                }

                // Return UI IS active: must be checked, otherwise block and show tooltip
                if (!activeCheckbox.checked) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                try {
                    activeCheckbox.focus({ preventScroll: true });
                } catch (_) {}
                // Browser tooltip / validation bubble
                if (typeof activeCheckbox.reportValidity === "function") activeCheckbox.reportValidity();
                else if (typeof f.reportValidity === "function") f.reportValidity();
                return;
                }

                // Dedupe: prevent double submission for the same variant in quick succession
                const guardKey = `finalSale|${thisFormVariantId || currentVariantId || ""}`;
                if (isGuarded(guardKey)) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                return;
                }

                // Normalize properties[Note] on the submitting form:
                // - If form contains checkbox, use it and disable others
                // - Otherwise inject a hidden proxy with the same value
                if (f.contains(activeCheckbox)) {
                activeCheckbox.value = MESSAGE;
                activeCheckbox.disabled = false;
                activeCheckbox.required = true;
                disableAllOtherNoteInputsInForm(f, activeCheckbox);
                } else {
                const proxy = ensureProxyNoteInput(f);
                proxy.disabled = false;
                proxy.value = MESSAGE;
                disableAllOtherNoteInputsInForm(f, proxy);
                }
            },
            true
            );
        };

        // Bind guard to all cart/add forms once (main + sticky, etc.)
        returnLogicRoot
            .querySelectorAll('form[action^="/cart/add"], form[action="/cart/add"]')
            .forEach(bindSubmitGuardToForm);
        if (baseForm) bindSubmitGuardToForm(baseForm);

        // ----- Init + listeners -----

        update();

        if (baseForm) {
            baseForm.addEventListener("change", (e) => {
            // don't re-run on the checkbox toggle; preserve the user's check state
            if (e?.target?.matches?.('input[name="properties[Note]"]')) return;
            requestAnimationFrame(update);
            });
        }

        this.addEventListener("change", () => requestAnimationFrame(update));

        window.addEventListener("popstate", () => requestAnimationFrame(update));

        if (variantIdInput) {
            const obs = new MutationObserver(() => update());
            obs.observe(variantIdInput, { attributes: true, attributeFilter: ["value"] });
        }
    }
  handleFreeShippingExcludedLogic() {
    const customFreeShippingExcludedData = document.querySelector("[custom-free-shipping-excluded-data]");
    //console.log("customFreeShippingExcludedData", customFreeShippingExcludedData);
    if (!customFreeShippingExcludedData) return;
    const customFreeShippingExcludedTextElem = document.querySelector(".custom-free-shipping-excluded-text");
    const productJson = JSON.parse(customFreeShippingExcludedData.textContent);
    const groupedByOption1 = productJson.variants.reduce((acc, variant) => {
      const key = handleize(variant.option1);
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push({
        id: variant.id,
        option1: variant.option1,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
      });
      return acc
    }, {});
    const variantsPriceMasterObject = Object.entries(groupedByOption1).reduce((masterObj, [color, variants]) => {
      const prices = variants.map((v) => v.price);
      const compareAtPrices = variants.map((v) => v.compare_at_price);
      masterObj[color] = {
        minPrice: Math.min(...prices),
        maxCompareAtPrice: Math.max(...compareAtPrices),
      };
      return masterObj
    }, {});
    const searchParams = new URLSearchParams(window.location.search);
    const colorParamValue = searchParams.get("color-print-name");
    const label = customFreeShippingExcludedTextElem.querySelector("label");
    const inputs = customFreeShippingExcludedTextElem.querySelectorAll(
      'input[name="properties[Note]"]'
    );
    Object.entries(variantsPriceMasterObject).forEach(([color, {
      minPrice,
      maxCompareAtPrice
    }]) => {
      if (colorParamValue === color) {
        const shouldShow = minPrice <= maxCompareAtPrice;
        //console.log("minPrice", minPrice);
        //console.log("maxCompareAtPrice", maxCompareAtPrice);
        //console.log(shouldShow ? "FreeShippingExcluded checkbox showing" : "FreeShippingExcluded checkbox hiding");
        label.style.display = shouldShow ? "block" : "none";
        inputs.forEach((input) => {
          input.value = shouldShow ? "Free Shipping Excluded" : "";
          input.checked = !shouldShow;
          input.style.display = shouldShow ? "block" : "none"
        })
      }
    })
  }
  async updateOptions(targetName, init = !1) {
    if (!Array.isArray(this.options)) {
      this.options = []
    }
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset, index) => {
      const checkedInput = Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked);
      if (this.options[index] && checkedInput && this.options[index] === checkedInput.value) {
        return this.options[index]
      }
      return checkedInput ? checkedInput.value : this.options[index]
    });
    const inputRadios = this.querySelectorAll('shop-the-look-products-form variant-radios input[type="radio"]');
    const colorSwatchLabels = this.querySelectorAll("shop-the-look-products-form variant-radios label.color-swatch");
    if (colorSwatchLabels?.length > 1) {
      inputRadios?.forEach((radio) => {
        if (radio.nextElementSibling.tagName === "LABEL") {
          radio.nextElementSibling.classList.remove("selected")
        }
      })
    }
    if (colorSwatchLabels?.length === 1) {
      inputRadios?.forEach((radio) => {
        if (radio.nextElementSibling.tagName === "LABEL" && !radio.nextElementSibling.classList.contains("color-swatch")) {
          radio.nextElementSibling.classList.remove("selected")
        }
      })
    }
    inputRadios?.forEach((radio) => {
      if (radio.checked && radio.nextElementSibling.tagName === "LABEL") {
        radio.nextElementSibling.classList.add("selected")
      }
    });
    const initOption = this.getAttribute("selected-or-first-available-variant-option-0");
    const productHandle = fieldsets[0].getAttribute("product-handle");
    const colorOptionCount = [...fieldsets[0].querySelectorAll("input")].length;
    const price = document.getElementById(`price-${this.dataset.sectionOnly ? this.dataset.sectionOnly : this.dataset.section}`);
    price?.classList.remove("visibility-hidden");
    this.revealProductPrices();
    let data;
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error(`Product JSON request failed (${response.status})`);
      }
      data = await response.json();
    } catch (error) {
      console.warn("[VariantRadios] Skipping tag-based PDP logic because product JSON could not be loaded.", {
        productHandle,
        error,
      });
      this.updateMedia();
      return;
    }
    const colorFieldset = getColorPrintFieldset(this);
    const colorOptionIndex = colorFieldset ? fieldsets.indexOf(colorFieldset) : 0;
    const selectedColorCandidates = getOptionMatchCandidates(
      this,
      colorOptionIndex,
      this.options[colorOptionIndex] || this.options[0]
    );
    const initVariant = data.variants.find((variant) => {
      const variantColor =
        variant.options?.[colorOptionIndex] ||
        variant[`option${colorOptionIndex + 1}`] ||
        variant.option1 ||
        "";

      if (selectedColorCandidates.length > 0) {
        return selectedColorCandidates.some((candidate) => optionValueMatches(candidate, variantColor));
      }
      return !1
    });

    // If nothing matched the current selection (e.g. gift card / odd cases),
    // bail out and let the core variant flow handle price, URL, etc.
    if (!initVariant) {
      // We already updated this.options above, so updateMasterId + renderProductInfo
      // will still work. We just skip all the extra color/badge/discount logic.
      return;
    }

    // >>> PDP badge parity with PLP (show_badge_child_level)
    // Requires helpers from Step 1: _toUnderscore, _shouldShowNewish, _applyNewishVisibility
    this.__productTags = data.tags || [];
    const currentColorForBadges = (this.options?.[0]) || initVariant?.option1 || "";
    _applyNewishVisibility(_shouldShowNewish(this.__productTags, currentColorForBadges));
    // <<< end badge parity

    const shopTheLookProductsForm = this.closest("shop-the-look-products-form");
    if (shopTheLookProductsForm) {
      const shopTheLookProductImage = shopTheLookProductsForm.querySelector(`product-info[id*="${initVariant.featured_image.product_id}"] .product-media-wrapper img`);
      if (shopTheLookProductImage) {
        shopTheLookProductImage.src = `${initVariant.featured_image.src}&width=180`
      }
    }
    const tagBasedDiscountTag = data.tags.find((tag) => /^\d+_off$/.test(String(tag || "").trim()));
    const tagBasedDiscountAmount = Number(tagBasedDiscountTag?.split("_off")[0]);
    let tagBasedDiscountPercentage = Number.isFinite(tagBasedDiscountAmount)
      ? (100 - tagBasedDiscountAmount) / 100
      : null;
    let excludeTagBasedDiscount = data.tags.find((tag) => String(tag || "").includes("_off:exclude:"));
    let excludeTagBasedColor = excludeTagBasedDiscount?.split("_off:exclude:")[1];
    //console.log("initVariant", initVariant);
    let variantHandle = handleize(initVariant.option1);
    const searchParams = new URLSearchParams(window.location.search);

    if (colorOptionIndex >= 0 && this.options[colorOptionIndex]) {
      searchParams.set("color-print-name", handleize(this.options[colorOptionIndex]));
    } else {
      searchParams.delete("color-print-name");
    }

    if (this.currentVariant) {
      searchParams.set("variant", this.currentVariant.id);
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({ path: newUrl }, "", newUrl);
    let excludeDiscount = !1;
    if (excludeTagBasedColor && variantHandle.includes(handleize(excludeTagBasedColor))) {
      excludeDiscount = !0
    }
    this.__tagBasedDiscountPercentage = tagBasedDiscountPercentage;
    this.__excludeDiscount = excludeDiscount;
    let selectedPrice = initVariant.price;
    const availableVariants = data.variants.filter((variant) => variant.available);
    const unavailableVariants = data.variants.filter((variant) => !variant.available);
    // Build available/unavailable variants scoped by exact color match
    const initAvailableVariants = data.variants.filter(
      (v) =>
        v.available &&
        (v.option1 || "").toLowerCase() === (initVariant.option1 || "").toLowerCase()
    );
    const initUnavailableVariants = data.variants.filter(
      (v) =>
        !v.available &&
        (v.option1 || "").toLowerCase() === (initVariant.option1 || "").toLowerCase()
    );
    let availableSizes = [];
    let availableColors = [];
    let unavailableSizes = [];
    let unavailableColors = [];
    if (isColorPrintOptionName(targetName)) {
      if (colorOptionCount === 1) {
        availableSizes = availableVariants.map((v) => v.option2);
        unavailableSizes = unavailableVariants.map((v) => v.option2)
      } else {
        availableSizes = availableVariants.filter((v) => optionValueMatches(v.option1, initVariant.option1) && v.option2).map((v) => v.option2);
        unavailableSizes = unavailableVariants.filter((v) => optionValueMatches(v.option1, initVariant.option1) && v.option2).map((v) => v.option2)
      }
      if (unavailableSizes.length === 0 || availableSizes.length > 1) {
        if (document.querySelector("#add-to-cart span")) { }
      }
      if (initUnavailableVariants.length > 0) {
        // ALWAYS re-apply availability classes for Size labels
        const sizeFieldset = this.querySelector(
          'fieldset[option-name="Size"], fieldset[option-name="Taille"], fieldset[option-name="Größe"], fieldset[option-name="Misurare"]'
        );
        if (sizeFieldset) {
          const labels = [...sizeFieldset.querySelectorAll('label[variant-title]')];

          // Build the list of unavailable sizes for the CURRENT color, exactly matched
          const initAvailableVariants = data.variants.filter(
            (v) =>
              v.available &&
              (v.option1 || '').toLowerCase() === (initVariant.option1 || '').toLowerCase()
          );
          const initUnavailableVariants = data.variants.filter(
            (v) =>
              !v.available &&
              (v.option1 || '').toLowerCase() === (initVariant.option1 || '').toLowerCase()
          );

          const initUnavailableSizes = initUnavailableVariants.map((v) => v.option2);

          // Apply/clear classes every time (prevents stale styling after a color change)
          labels.forEach((label) => {
            const val = (label.getAttribute('value') || '').trim();
            const isUnavailable = initUnavailableSizes.includes(val);
            label.classList.toggle('label-unavailable-styling', isUnavailable);
          });
        }

      }
    } else if (targetName === "Size") {
      if (unavailableColors === 1) {
        unavailableColors = unavailableVariants.map((v) => v.option1)
      } else {
        unavailableColors = unavailableVariants.filter((v) => v.option2 === this.options[1] && v.option1).map((v) => v.option1)
      }
    } else { }
    const colorSelectedOption = colorFieldset?.querySelector("[selected-option]");
    if (colorSelectedOption && colorOptionIndex >= 0 && this.options[colorOptionIndex]) {
      colorSelectedOption.innerText = this.options[colorOptionIndex]
    } else { }
    if (this.options[1]) {
      this.querySelector('span[selected-option="size"], span[selected-option="taille"], span[selected-option="grosse"], span[selected-option="misurare"]').innerText = this.options[1]
    }
    // ---- BEGIN enforceSizeAvailability (always run) ----
    (() => {
      const sizeFieldset = this.querySelector(
        'fieldset[option-name="Size"], fieldset[option-name="Taille"], fieldset[option-name="Größe"], fieldset[option-name="Misurare"]'
      );
      if (!sizeFieldset) return;

      // Build fresh unavailable sizes for the CURRENT color
      // using exact equality on option1 (color)
      const unavailableSizes = data.variants
        .filter(
          (v) =>
            !v.available &&
            (v.option1 || "").toLowerCase() ===
            (initVariant.option1 || "").toLowerCase()
        )
        .map((v) => v.option2);

      const labels = [...sizeFieldset.querySelectorAll('label[variant-title]')];

      // Clear stale classes first
      labels.forEach((l) => l.classList.remove("label-unavailable-styling"));

      // Apply current state
      //console.groupCollapsed("[Variants] enforceSizeAvailability");
      //console.log("color:", initVariant.option1);
      //console.log("unavailableSizes:", unavailableSizes);
      labels.forEach((label) => {
        const val = (label.getAttribute("value") || "").trim();
        const isUnavailable = unavailableSizes.includes(val);
        label.classList.toggle("label-unavailable-styling", isUnavailable);
        //console.log("label", val, "→", isUnavailable ? "UNAVAILABLE" : "available");
      });
      console.groupEnd();
    })();
    // ---- END enforceSizeAvailability ----

    if (availableVariants.length === 1) {
      this.parentElement.querySelector("#add-to-cart")?.removeAttribute("disabled");
      if (this.parentElement.querySelector("#add-to-cart span")) {
        this.parentElement.querySelector("#add-to-cart span").innerHTML = window.variantStrings.addToCart
      }
    }
    if (availableSizes.length > 0) {
      const sizesWrapper = document.querySelector('fieldset.product-form__input[option-name="Size"], fieldset.product-form__input[option-name="Taille"], fieldset.product-form__input[option-name="Größe"], fieldset.product-form__input[option-name="Misurare"]');
      const sizeLabels = [...sizesWrapper.querySelectorAll("label[variant-title]")];
      sizeLabels.forEach((label) => {
        if (availableSizes.includes(label.getAttribute("value"))) { }
      })
    }
    if (availableSizes.length === 1) {
      const sizeInput = this.querySelector(`input[value="${availableSizes[0]}"]`);
      if (sizeInput) {
        const atcButton = this.closest(".product__info-container").querySelector(".product-form__submit.button");
        if (!this.currentVariant && atcButton) { }
        if (atcButton && sizeInput.checked) {
          setTimeout(() => {
            atcButton.querySelector("span").innerHTML = "Add to cart";
            atcButton.removeAttribute("disabled")
          }, 500)
        }
      }
    }
    if (this.currentVariant && !this.currentVariant.available) {
      if (this.parentElement.querySelector("button[id][type='submit'][name='add']")) {
        this.parentElement.querySelector("button[id][type='submit'][name='add']").disabled = !0
      }
      if (this.parentElement.querySelector("button[id][type='submit'][name='add'] span")) {
        this.parentElement.querySelector("button[id][type='submit'][name='add'] span").innerHTML = window.variantStrings.soldOut
      }
    }
    if (this.currentVariant && this.currentVariant.available) {
      this.parentElement.querySelector("button[id][type='submit'][name='add']")?.removeAttribute("disabled");
      if (this.parentElement.querySelector("button[id][type='submit'][name='add'] span")) {
        this.parentElement.querySelector("button[id][type='submit'][name='add'] span").innerHTML = window.variantStrings.addToCart
      }
      if (document.querySelector("#add-to-cart span")) {
        document.querySelector("#add-to-cart span").innerText = window.variantStrings.addToCart
      }
    }
    if (this.currentVariant) {
      this.setAttribute("data-variant-id", this.currentVariant.id);
      this.setAttribute("data-variant-available", this.currentVariant.available);
      if (shopTheLookProductsForm) {
        shopTheLookProductsForm.updateButtonState()
      }
      selectedPrice = this.currentVariant.price
    }
    if (price) {
      const regularPriceElem = price.querySelector(".price-item.price-item--regular");
      const salePriceElem = price.querySelector(".price-item.price-item--sale");
      if (regularPriceElem) regularPriceElem.classList.remove("tag-based-line-through-price");
      if (regularPriceElem && tagBasedDiscountPercentage && !excludeDiscount) {
        regularPriceElem.classList.add("tag-based-line-through-price")
      }
      const lineThroughPriceSalePriceRegularElem = price.querySelector(
        ".price__sale .price-item.price-item--regular"
      );
      const pricingVariant = this.currentVariant || initVariant;
      const lineThroughPriceSalePriceRegular = pricingVariant.price;
      const sizeFieldsetForPrice = this.querySelector(
        'fieldset[option-name="Size"], fieldset[option-name="Taille"], fieldset[option-name="Größe"], fieldset[option-name="Misurare"]'
      );
      const sizeOptionIndexForPrice = sizeFieldsetForPrice ? fieldsets.indexOf(sizeFieldsetForPrice) : -1;
      const selectedSizeForPrice = sizeOptionIndexForPrice >= 0 ? this.options[sizeOptionIndexForPrice] : "";
      const colorFieldsetForPrice = getColorPrintFieldset(this);
      const colorOptionIndexForPrice = colorFieldsetForPrice ? fieldsets.indexOf(colorFieldsetForPrice) : -1;
      const selectedColorForPrice = colorOptionIndexForPrice >= 0 ? this.options[colorOptionIndexForPrice] : "";
      const pricesForRange = data.variants
        .filter((variant) => {
          if (!variant.available) return false;
          if (colorOptionIndexForPrice < 0 || !selectedColorForPrice) return true;
          const variantColor = variant.options?.[colorOptionIndexForPrice] || variant[`option${colorOptionIndexForPrice + 1}`] || "";
          return String(variantColor).toLowerCase() === String(selectedColorForPrice).toLowerCase();
        })
        .map((variant) => Number(variant.price))
        .filter((variantPrice) => Number.isFinite(variantPrice) && variantPrice > 0);
      const minPriceForRange = pricesForRange.length ? Math.min(...pricesForRange) : null;
      const maxPriceForRange = pricesForRange.length ? Math.max(...pricesForRange) : null;
      const shouldShowUnselectedSizeRange =
        sizeFieldsetForPrice &&
        sizeFieldsetForPrice.querySelectorAll("input").length > 1 &&
        !selectedSizeForPrice &&
        !this.currentVariant &&
        Number.isFinite(minPriceForRange) &&
        Number.isFinite(maxPriceForRange) &&
        maxPriceForRange > minPriceForRange;
      const selectedPriceHtml = shouldShowUnselectedSizeRange
        ? `${currencySymbol}${(minPriceForRange / 100).toFixed(2)} - ${currencySymbol}${(maxPriceForRange / 100).toFixed(2)} ${window.Shopify.currency.active}`
        : `${currencySymbol}${(selectedPrice / 100).toFixed(2)} ${window.Shopify.currency.active}`;
      if (shouldShowUnselectedSizeRange && regularPriceElem) {
        regularPriceElem.classList.remove("tag-based-line-through-price");
      }
      if (regularPriceElem) regularPriceElem.innerHTML = selectedPriceHtml;
      if (salePriceElem) salePriceElem.innerHTML = selectedPriceHtml;
      const priceSale = shouldShowUnselectedSizeRange ? null : pricingVariant.compare_at_price;
      if (shouldShowUnselectedSizeRange) {
        const price__sale = price.querySelector(".price__sale");
        if (price__sale) price__sale.style.display = "none";
        const price__regular = price.querySelector(".price__regular");
        if (price__regular) price__regular.style.display = "block";
      } else if (window.location.href && !window.location.href.includes("variant=")) {
        const price__sale = price.querySelector(".price__sale");
        if (price__sale) price__sale.style.display = 'block'
        const price__regular = price.querySelector(".price__regular");
        if (price__regular) price__regular.style.display = 'none'
      }

      function updatePriceDisplay(lineThroughPriceSalePriceRegular, priceSale) {
        const lineThroughPriceElem =
          lineThroughPriceSalePriceRegularElem?.closest(".price-item--regular-wrapper");

        const mediaContainers = document.querySelectorAll(
          ".product-media-container.media-type-image"
        );

        const currentPrice = Number(lineThroughPriceSalePriceRegular || 0);
        const compareAtPrice = Number(priceSale || 0);
        const isDiscounted = compareAtPrice > currentPrice;

        if (lineThroughPriceSalePriceRegularElem && isDiscounted) {
          lineThroughPriceSalePriceRegularElem.textContent =
            `${currencySymbol}${(compareAtPrice / 100).toFixed(2)} ${window.Shopify.currency.active}`;
        }

        if (lineThroughPriceElem) {
          lineThroughPriceElem.classList.toggle("display-none", !isDiscounted);
        }

        const priceRoot = price.querySelector(".price");
        const regularPriceContainer = price.querySelector(".price__regular");
        const salePriceContainer = price.querySelector(".price__sale");
        if (priceRoot) priceRoot.classList.toggle("price--on-sale", isDiscounted);
        if (regularPriceContainer) regularPriceContainer.style.display = isDiscounted ? "none" : "block";
        if (salePriceContainer) salePriceContainer.style.display = isDiscounted ? "block" : "none";

        // Remove every existing Sale badge first
        document.querySelectorAll(".product__custom_label.position_top").forEach((node) => {
          if ((node.textContent || "").trim().toLowerCase() === "sale") {
            node.remove();
          }
        });

        // If the current variant is not discounted, stop here
        if (!isDiscounted) return;

        // Re-add Sale badges using the same placement logic that was already working before
        mediaContainers.forEach((mediaContainer) => {
          let saleLabel = Array.from(
            mediaContainer.querySelectorAll(".product__custom_label.position_top")
          ).find((node) => (node.textContent || "").trim().toLowerCase() === "sale");

          if (!saleLabel) {
            saleLabel = document.createElement("span");
            saleLabel.classList.add("product__custom_label", "position_top");
            saleLabel.textContent = "Sale";
            mediaContainer.appendChild(saleLabel);
          }
        });
      }

      updatePriceDisplay(shouldShowUnselectedSizeRange ? 0 : lineThroughPriceSalePriceRegular, priceSale);
      if (!shouldShowUnselectedSizeRange) {
        this.applyTagBasedDiscountPrices(selectedPrice);
        requestAnimationFrame(() => this.applyTagBasedDiscountPrices(selectedPrice));
        setTimeout(() => this.applyTagBasedDiscountPrices(selectedPrice), 250);
      }
    }
    const quickAddModal = document.querySelector(`quick-add-modal[id=QuickAdd-${this.currentVariant?.featured_image.product_id}]`);
    if (this.currentVariant && !this.currentVariant.available && quickAddModal) {
      const quickAddBis = quickAddModal.querySelector(".test-bis");
      if (quickAddBis) {
        quickAddBis.style.display = "flex"
      }
    }
    if (this.currentVariant && this.currentVariant.available && quickAddModal) {
      const quickAddBis = quickAddModal.querySelector(".test-bis");
      if (quickAddBis) {
        quickAddBis.style.display = "none"
      }
    }
    if (isColorPrintOptionName(targetName) && !init && !this.dataset.updateUrl === "false") {
      location.reload()
    }
    this.updateMedia();
    (() => {
      // 1) Remove any existing badges (including hard-coded mobile swiper ones)
      document
        .querySelectorAll('#custom-mobile-swiper-container .product__custom_label, .product__media .product__custom_label')
        .forEach(n => n.remove());

      // 2) Build PLP-equivalent rule set
      const productTags = data.tags || [];
      // Keep this list in sync with PLP BADGE_TAGS; include the tags you actually use on PLP
      const BADGE_TAGS = ['New', 'Just Arrived', 'Best Seller', 'Limited', 'Online Exclusive'];

      const currentColor = (initVariant?.option1 || this.options?.[0] || '').trim();
      const colorHandleUnderscore = handleize(currentColor).replace(/-/g, '_');

      const hasChildLevel = productTags.some(t => t.includes('show_badge_child_level'));
      const hasVariantBadge = productTags.some(t => t === `show_badge:${colorHandleUnderscore}`);

      // PLP rules:
      // - No show_badge_child_level => show all BADGE_TAGS present
      // - show_badge_child_level & NO show_badge:<color> => show BADGE_TAGS except "New" & "Just Arrived"
      // - show_badge_child_level & show_badge:<color> => show all BADGE_TAGS present
      let tagsToShow = [];
      if (!hasChildLevel) {
        tagsToShow = productTags.filter(t => BADGE_TAGS.includes(t));
      } else if (hasChildLevel && !hasVariantBadge) {
        tagsToShow = productTags.filter(t => BADGE_TAGS.includes(t) && t !== 'New' && t !== 'Just Arrived');
      } else {
        tagsToShow = productTags.filter(t => BADGE_TAGS.includes(t));
      }

      // If there’s an _off:exclude:<color> tag, don’t show a "Sale" label for that color
      const excludeTag = productTags.find(t => t.startsWith('_off:exclude:'));
      const excludeColor = excludeTag ? excludeTag.split(':exclude:')[1] : '';
      const isExcludedColor = excludeColor && handleize(currentColor).includes(excludeColor);
      if (isExcludedColor) {
        tagsToShow = tagsToShow.filter(t => t !== 'Sale');
      }

      // 3) Render the badges onto the active gallery image
      if (tagsToShow.length) {
        const activeMedia = document.querySelector('li.product__media-item.slider__slide.is-active .product__media.media');
        if (activeMedia) {
          tagsToShow.forEach(tag => {
            const el = document.createElement('span');
            el.className = 'product__custom_label position_top';
            el.textContent = tag;
            activeMedia.appendChild(el);
          });
        }
      }
    })();

    this.handleFreeShippingExcludedLogic();
    this.handleProductReturnLogic()
  }
  syncOptions() {
    const fieldsets = this.querySelectorAll("fieldset");
    this.options.forEach((optionValue, index) => {
      fieldsets[index].querySelectorAll("input").forEach((inputElement) => {
        inputElement.checked = inputElement.value == optionValue
      })
    })
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url).then((response) => response.text()).then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        }
        if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
          this.remove()
        }
        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded")
        }
      }).catch((e) => {
        console.error(e)
      })
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this)
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class GrapheneCarouselTEST {
  constructor(carouselWrapper) {
    this.carousel = carouselWrapper.querySelector(".acs-carousel");
    this.prevBtn = carouselWrapper.querySelector("button.acs-carousel-btn[aria-label='Previous Slide']");
    this.nextBtn = carouselWrapper.querySelector("button.acs-carousel-btn[aria-label='Next Slide']");
    this.totalSlides = parseInt(this.carousel?.getAttribute("data-slides"));
    this.lastSlide = this.getTotalSlides(this.totalSlides);
    this.translateWidth = this.carousel?.offsetWidth;
    this.prevBtn?.addEventListener("click", this.handlePrevSlide.bind(this));
    this.nextBtn?.addEventListener("click", this.handleNextSlide.bind(this))
  }
  getTotalSlides(totalSlides) {
    const screenSize = window.innerWidth;
    let productsPerSlide = 2;
    return Math.ceil(totalSlides / productsPerSlide)
  }
  getCurrentSlide() {
    return parseInt(this.carousel.getAttribute("data-current-slide"))
  }
  setCurrentSlide(index) {
    this.carousel.setAttribute("data-current-slide", index)
  }
  setIsLastSlide(value) {
    this.carousel.setAttribute("data-on-last-slide", value)
  }
  handlePrevSlide(e) {
    const currentSlide = this.getCurrentSlide();
    if (currentSlide === 1) return;
    const newSlideIndex = currentSlide - 1;
    this.setIsLastSlide("false");
    this.carousel.setAttribute("style", `transform:translateX(${-(this.translateWidth * newSlideIndex) + this.translateWidth}px)`);
    this.setCurrentSlide(newSlideIndex)
  }
  handleNextSlide(e) {
    const currentSlide = this.getCurrentSlide();
    if (currentSlide === this.lastSlide) return;
    const newSlideIndex = currentSlide + 1;
    if (newSlideIndex === this.lastSlide) this.setIsLastSlide("true");
    this.carousel.setAttribute("style", `transform:translateX(-${this.translateWidth * newSlideIndex - this.translateWidth}px)`);
    this.setCurrentSlide(newSlideIndex)
  }
}
class ProductCarouselTEST extends GrapheneCarouselTEST {
  constructor(carouselWrapper) {
    super(carouselWrapper);
    this.carousel = carouselWrapper.querySelector(".product-carousel");
    this.prevBtn = carouselWrapper.querySelector("button.product-carousel-btn[aria-label='Previous Slide']");
    this.nextBtn = carouselWrapper.querySelector("button.product-carousel-btn[aria-label='Next Slide']");
    this.totalSlides = parseInt(this.carousel.getAttribute("data-slides"));
    this.lastSlide = this.getTotalSlides(this.totalSlides);
    this.translateWidth = this.carousel.offsetWidth;
    this.prevBtn.addEventListener("click", this.handlePrevSlide.bind(this));
    this.nextBtn.addEventListener("click", this.handleNextSlide.bind(this))
  }
  getTotalSlides(totalSlides) {
    const screenSize = window.innerWidth;
    let productsPerSlide = 1;
    if (screenSize < 1190) productsPerSlide = 4;
    if (screenSize < 990) productsPerSlide = 3;
    if (screenSize < 768) productsPerSlide = 2;
    return Math.ceil(totalSlides / productsPerSlide)
  }
}
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const descriptionElement = document.querySelector(".collection-hero__description.rte");
    if (descriptionElement) {
      descriptionElement.style.display = "block"
    }
  }, 2000)
});

function handleizeSwatchValue(value) {
  if (typeof handleize === "function") {
    return handleize(value)
  }

  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

function colorFallbackForSwatchValue(value) {
  const text = handleizeSwatchValue(value);
  const colorMatches = [
    [/navy|marine|starlight|bleu-marine|low-tide/, "#111253"],
    [/blue|bleu|capri|bellevue|turquoise|aqua|wave|vague/, "#49c7d4"],
    [/pink|rose|conch|coquillage|blush|quartz|parigi/, "#f5b6c8"],
    [/green|vert|kitts|putting|crocodile|pistachio/, "#6fbe78"],
    [/gold|(^|-)or($|-)|metallic|metallise/, "#d6af37"],
    [/white|blanc|coconut|resort/, "#f8f7f2"],
    [/black|noir|onyx/, "#101014"],
    [/red|rouge|cranberry|cherry/, "#c73545"],
    [/purple|violet|lilac|lavender/, "#9b7ac9"],
    [/orange|coral|peach/, "#f28c5b"],
    [/yellow|jaune|sunny/, "#f5d451"]
  ];

  const match = colorMatches.find(([pattern]) => pattern.test(text));
  return match ? match[1] : ""
}

function swatchUrlForCandidate(sourceUrl, candidate) {
  const swatchHandle = handleizeSwatchValue(candidate);
  if (!sourceUrl || !swatchHandle) return "";

  const replacement = `color-${swatchHandle}.png`;
  if (/color-[^/?#]+\.png/i.test(sourceUrl)) {
    return sourceUrl.replace(/color-[^/?#]+\.png/i, replacement)
  }

  return ""
}

function testSwatchImage(url) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = url
  })
}

function extractMediaSwatchCandidates() {
  const candidates = [];
  const addCandidate = (candidate) => {
    const cleanedCandidate = (candidate || "")
      .replace(/\.(jpe?g|png|webp|gif)$/i, "")
      .replace(/[-_\s]*\d+$/g, "")
      .replace(/[-_\s]+/g, " ")
      .trim();

    if (cleanedCandidate && !candidates.includes(cleanedCandidate)) {
      candidates.push(cleanedCandidate)
    }
  };

  document.querySelectorAll("media-gallery img[alt], .product__media img[alt]").forEach((image) => {
    const alt = image.getAttribute("alt") || "";
    const dashIndex = alt.indexOf(" - ");
    if (dashIndex !== -1) {
      addCandidate(alt.slice(dashIndex + 3))
    }

    const src = image.currentSrc || image.getAttribute("src") || "";
    const filename = decodeURIComponent(src.split("/").pop().split("?")[0] || "");
    addCandidate(filename)
  });

  return candidates
}

async function applyColorSwatchImageFallbacks(root = document) {
  const selector = "label.color-swatch, a.color-swatch";
  const swatches = root.matches && root.matches(selector) ? [root] : root.querySelectorAll(selector);
  let mediaCandidates;

  for (const swatch of swatches) {
    if (swatch.dataset.swatchFallbackChecked === "true") continue;
    swatch.dataset.swatchFallbackChecked = "true";

    const backgroundTarget = swatch.querySelector(".temp-color-swatch") || swatch;
    const backgroundImage = backgroundTarget.style.backgroundImage || "";
    const match = backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
    const swatchImage = match && match[1];
    if (!swatchImage || swatchImage === "none") continue;
    if (await testSwatchImage(swatchImage)) continue;

    // Only scan product media when a missing swatch needs fallback candidates.
    if (!mediaCandidates) mediaCandidates = extractMediaSwatchCandidates();

    const optionValue = swatch.getAttribute("option-value") || swatch.getAttribute("value") || swatch.textContent || "";
    const swatchValue = swatch.getAttribute("data-swatch-value") || optionValue;
    const swatchImageValue = swatch.getAttribute("data-swatch-image-value") || "";
    const knownTranslatedCandidates = {
      "coquillage-de-conque-chine-rose": ["Heathered Conch Shell Pink", "Pink Heathered Conch Shell", "Conch Shell Pink Heathered"],
      "day-dream-blue-tends-moi-la-perche": ["Day Dream Blue Throw Me A Line"],
      "bleu-capri-chine": ["Heathered Capri Blue"],
      "turquoise-vague-perles-paillettes": ["Turquoise Wave Pearl Sequin", "Turquoise Wave Pearl Sequins"],
      "or-metallise": ["Gold Metallic", "Metallic Gold"],
      "cocktail-paradisiaque": ["Paradise Cocktail", "Cocktail Paradise"]
    };
    const knownCandidates = knownTranslatedCandidates[handleizeSwatchValue(optionValue)] || [];
    const candidates = [swatchImageValue, ...knownCandidates, swatchValue, optionValue, ...mediaCandidates];
    let recoveredSwatch = "";

    for (const candidate of candidates) {
      const candidateUrl = swatchUrlForCandidate(swatchImage, candidate);
      if (!candidateUrl || candidateUrl === swatchImage || candidateUrl === recoveredSwatch) continue;

      if (await testSwatchImage(candidateUrl)) {
        recoveredSwatch = candidateUrl;
        break
      }
    }

    if (recoveredSwatch) {
      backgroundTarget.style.backgroundImage = `url("${recoveredSwatch}")`
    } else {
      const fallbackColor = colorFallbackForSwatchValue(`${swatchValue} ${optionValue}`);
      backgroundTarget.style.backgroundImage = "none";
      if (fallbackColor) {
        backgroundTarget.style.backgroundColor = fallbackColor
      }
    }
  }
}

function observeColorSwatchImageFallbacks() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          applyColorSwatchImageFallbacks(node)
        }
      })
    })
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    applyColorSwatchImageFallbacks();
    observeColorSwatchImageFallbacks()
  })
} else {
  applyColorSwatchImageFallbacks();
  observeColorSwatchImageFallbacks()
}

class ShopTheLookProductsForm extends HTMLElement {
  constructor() {
    super();
    this.shopTheLookMainProductHandle = this.getAttribute("shop-the-look-main-product-handle");
    this.cart = document.querySelector("cart-drawer");
    this.forms = this.querySelectorAll("product-form")
  }
  connectedCallback() {
    const button = document.createElement("button");
    button.textContent = "Add All to Cart";
    button.classList.add("add-to-cart-button");
    button.disabled = !0;
    button.addEventListener("click", () => this.addAllToCart());
    this.appendChild(button)
  }
  updateButtonState() {
    const products = this.querySelectorAll("product-info");
    let allVariantsSelected = !0;
    products.forEach((product) => {
      const variantRadio = product.querySelector("variant-radios");
      const variantId = variantRadio ? variantRadio.getAttribute("data-variant-id") : null;
      const variantAvailable = variantRadio ? variantRadio.getAttribute("data-variant-available") === "true" : !1;
      if (!variantId || !variantAvailable) {
        allVariantsSelected = !1
      }
    });
    this.querySelector(".add-to-cart-button").disabled = !allVariantsSelected;
    this.querySelector(".add-to-cart-button").textContent = allVariantsSelected ? "ADD LOOK TO CART" : "SELECT ALL OPTIONS"
  }
  async addAllToCart() {
    const products = this.querySelectorAll("product-info");
    for (const product of products) {
      const variantId = product.querySelector("variant-radios").getAttribute("data-variant-id");
      if (variantId) {
        const form = product.querySelector("product-form form");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(form);
        formData.append("id", variantId);
        formData.append("quantity", 1);
        if (this.cart) {
          formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id));
          formData.append("sections_url", product.getAttribute("data-url"));
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData;
        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          if (!response.ok) throw new Error("Network response was not ok");
          const data = await response.json();
          //console.log("Products added to cart:", data);
          if (this.cart) {
            this.cart.renderContents(data);
            this.cart.classList.remove("is-empty")
          }
          closePopup(this.shopTheLookMainProductHandle);
          document.dispatchEvent(new CustomEvent("theme:cart-add", {
            bubbles: !0,
            cancelable: !1,
            detail: {
              isEmpty: !1
            },
          }))
        } catch (error) {
          console.error("There was a problem with the fetch operation:", error)
        }
      }
    }
  }
}
customElements.define("shop-the-look-products-form", ShopTheLookProductsForm)
